import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const listSkillVersions = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-versions`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getActiveSkillVersion = async (slug) => {
  const response = await axios.get(
    `${API_URL}/api/skill-versions/active/${encodeURIComponent(slug)}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const publishSkillVersion = async (skillFichaId) => {
  const response = await axios.post(
    `${API_URL}/api/skill-versions/publish`,
    { skillFichaId },
    { headers: authHeaders() },
  );
  return response.data;
};

export const getSkillVersionsDriveStatus = async () => {
  const response = await axios.get(`${API_URL}/api/skill-versions/drive-status`, {
    headers: authHeaders(),
  });
  return response.data;
};
